import { useCallback, useEffect } from 'react';

interface IInternetConnectionOptions {
  onlineCallback: () => void;
  offlineCallback: () => void;
}

const useInternetConnection = ({ onlineCallback, offlineCallback }: IInternetConnectionOptions) => {
  const checkInternetOnLoad = useCallback(() => {
    navigator.onLine ? onlineCallback() : offlineCallback();
  }, [offlineCallback, onlineCallback]);

  useEffect(() => {
    window.addEventListener('online', onlineCallback);
    window.addEventListener('offline', offlineCallback);
    window.addEventListener('load', checkInternetOnLoad);

    return () => {
      window.removeEventListener('online', onlineCallback);
      window.removeEventListener('offline', offlineCallback);
      window.removeEventListener('load', checkInternetOnLoad);
    };
  }, [checkInternetOnLoad, offlineCallback, onlineCallback]);
};

export default useInternetConnection;
